import { WeddingBuilderAccordionWorkspace } from '@/components/weddingTemplatesV2/WeddingBuilderAccordionWorkspace';

export const WeddingWebsiteBuilderSection = () => {
  return (
    <section data-testid="website-builder-v2-section-wrapper">
      <WeddingBuilderAccordionWorkspace templateKey="editorial-elegant" />
    </section>
  );
};
